import {connect} from 'react-redux';
import Component from './StreamList';
import { setHeaderTitle } from '../../../../actions/layout';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../../selectors/crud';
import {STREAM_ROUTER_EDIT, STREAM_ROUTER_VIEW} from '../constants';
import {push} from 'react-router-redux/lib/actions';
import {streamAction} from '../../../../actions/stream/liveStadiumStream';
import {getCurrentClubId} from '../../../../selectors/club-settings';

export default connect(
  (state) => ({
    ...listStateFromCRUD(state.liveStadiumStream),
    displayStatus: true,
    filter: {
      streamType: state.customStream.filter.streamType,
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => ({
    updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
    ...listDispatchFromCrud(dispatch, streamAction),
    edit: (id) => dispatch(push(STREAM_ROUTER_EDIT.replace(':id', id))),
    view: (id) => dispatch(push(STREAM_ROUTER_VIEW.replace(':id', id))),
    // add: () => dispatch(push(STREAM_ROUTER_NEW))
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamList/index.js